import { render, staticRenderFns } from "./NisConnectionsTable.vue?vue&type=template&id=5949936e"
import script from "./NisConnectionsTable.vue?vue&type=script&lang=js"
export * from "./NisConnectionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports